import { SearchOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import classNames from 'classnames/bind';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useSearchParams } from 'react-router-dom';
import RangePicker from '~/components/Common/RangePicker';
import { QuestionnaireCategory } from '~/models/common';
import { convertFilters } from '~/utils/questionnaire';
import FormItem from '~/components/Common/FormItem';

import styles from './index.module.scss';

interface IProps {
  setFilters?: (values: any) => void;
  isQuestionnaireScreen: boolean;
}

const cx = classNames.bind(styles);

export const FilterListQuestionnaire = ({
  setFilters,
  isQuestionnaireScreen,
}: IProps): React.ReactElement => {
  const { t } = useTranslation();
  const location = useLocation();
  const [form] = useForm();
  const [, setSearchParams] = useSearchParams();

  useEffect(() => {
    form.resetFields();
  }, [location.pathname]);

  const onFinish = (values: any): void => {
    setFilters?.(
      convertFilters({
        ...values,
        category: {
          equals: isQuestionnaireScreen
            ? QuestionnaireCategory.Questionnaire
            : QuestionnaireCategory.HealthCheckForm,
        },
      }),
    );
    setSearchParams(
      new URLSearchParams(
        JSON.parse(
          JSON.stringify({
            page: '1',
            ...values,
          }),
        ),
      ),
    );
  };

  return (
    <div className={cx('filter-wrapper')}>
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        onReset={(): void =>
          onFinish({
            category: {
              equals: isQuestionnaireScreen
                ? QuestionnaireCategory.Questionnaire
                : QuestionnaireCategory.HealthCheckForm,
            },
          })
        }
      >
        <Row gutter={[24, 5]}>
          <Col lg={6} sm={6}>
            <FormItem
              name="title"
              className={cx('form-item')}
              label={
                isQuestionnaireScreen
                  ? t('questionnaire.list.filter.title')
                  : t('healthCheck.list.filter.title')
              }
            >
              <Input
                className={cx('input-item')}
                placeholder={t('questionnaire.list.placeholder.search')!}
                suffix={<SearchOutlined className={cx('icon')} />}
              />
            </FormItem>
          </Col>
          <Col lg={8} sm={10}>
            <Form.Item
              name="createdAt"
              className={cx('form-item')}
              label={t('questionnaire.list.filter.createdAt')}
            >
              <RangePicker
                style={{
                  flex: 1,
                }}
                placeholder={[
                  t('questionnaire.list.placeholder.createdAt')!,
                  t('questionnaire.list.placeholder.createdAt')!,
                ]}
              />
            </Form.Item>
          </Col>
          <Col
            className={'flex align-center justify-end'}
            lg={{ span: 6, offset: 3 }}
            sm={{ span: 6, offset: 2 }}
          >
            <Button className={cx('btn')} htmlType="reset">
              {t('common.btn-clear')}
            </Button>
            <Button type="primary" htmlType="submit">
              {t('common.btn-search')}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
